export const GET_CURRANCIES_REQUEST = "GET_CURRANCIES_REQUEST";
export const GET_CURRANCIES_RESPONSE = "GET_CURRANCIES_RESPONSE";

export const GET_BRANCHES_LOOKUP_REQUEST = 'GET_BRANCHES_LOOKUP_REQUEST';
export const GET_BRANCHES_LOOKUP_RESPONSE = 'GET_BRANCHES_LOOKUP_RESPONSE';

export const GET_PROVIDERS_LOOKUP_REQUEST = 'GET_PROVIDERS_LOOKUP_REQUEST';
export const GET_PROVIDERS_LOOKUP_RESPONSE = 'GET_PROVIDERS_LOOKUP_RESPONSE';

export const GET_SPECIALITIES_LOOKUP_REQUEST = "GET_SPECIALITIES_LOOKUP_REQUEST";
export const GET_SPECIALITIES_LOOKUP_REASPONSE = "GET_SPECIALITIES_LOOKUP_REASPONSE";

export const GET_SERVICES_LOOKUP_REQUEST = 'GET_SERVICES_LOOKUP_REQUEST';
export const GET_SERVICES_LOOKUP_RESPONSE = 'GET_SERVICES_LOOKUP_RESPONSE';
